import {
    DayBadgesWrapper,
    DayHighlightBadgeWrapper,
    DayWrapper,
    Number,
} from './styles'
import { Moment } from 'moment'
import CalendarLegendBadge, {
    LegendBadgeIconType,
} from 'components/global/CalendarModal/components/CalendarModalLegend/components/CalendarLegendItem/components/CalendarLegendBadge'

interface DayProps {
    dayToRender: Moment
    isHighlighted?: boolean
    colorBadgeColors?: string[]
    iconBadgeIcons?: LegendBadgeIconType[]
    unlimitedEntryType?: string
    hasDarkMode?: boolean
    testId?: string
}

const Day = ({
    dayToRender,
    isHighlighted,
    colorBadgeColors,
    iconBadgeIcons,
    unlimitedEntryType,
    hasDarkMode,
    testId,
}: DayProps) => {
    const isIconBadgeVisible = !!iconBadgeIcons?.length
    const isColorBadgeVisible = !!colorBadgeColors?.length
    const hasCustomBadges = isIconBadgeVisible || isColorBadgeVisible

    return (
        <DayWrapper
            direction="row"
            pt={[8, 11]}
            pb={[8, 11]}
            pl={[0, 14]}
            pr={[0, 14]}
            hasHighlight={!!isHighlighted}
            hasDarkMode={hasDarkMode}
            data-testid={testId}
        >
            {hasCustomBadges && (
                <DayBadgesWrapper>
                    {isIconBadgeVisible &&
                        iconBadgeIcons.map((icon) => (
                            <CalendarLegendBadge
                                badge="icon"
                                badgeIcon={icon}
                                key={icon}
                                hasDarkMode={hasDarkMode}
                            />
                        ))}
                    {isColorBadgeVisible &&
                        colorBadgeColors.map((color) => (
                            <CalendarLegendBadge
                                badge="color"
                                badgeColor={color}
                                key={color}
                                hasDarkMode={hasDarkMode}
                            />
                        ))}
                </DayBadgesWrapper>
            )}
            {isHighlighted && (
                <DayHighlightBadgeWrapper hasCustomBadges={hasCustomBadges}>
                    <CalendarLegendBadge
                        badge="highlight"
                        hasDarkMode={hasDarkMode}
                    />
                </DayHighlightBadgeWrapper>
            )}

            <Number
                // TODO: remove this prop and rewrite using <CalendarLegendBadge />
                unlimitedEntryType={
                    unlimitedEntryType ? unlimitedEntryType : ''
                }
            >
                {dayToRender.format('D')}
            </Number>
        </DayWrapper>
    )
}

export default Day
